'use client';

import React, { useEffect } from 'react';
import SectionWrapper from '@/components/SectionWrapper';
import { FaExclamationTriangle, FaSync, FaHome } from 'react-icons/fa';  // ← FaSync replaces FaRefresh

export default function BlogError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Captured Blog Error:', error);
  }, [error]);

  return (
    <SectionWrapper bgColor="bg-white dark:bg-gray-900">
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <div className="bg-red-50 dark:bg-red-900/10 p-8 rounded-3xl border border-red-100 dark:border-red-900/30 max-w-lg w-full shadow-sm">
          <div className="bg-red-100 dark:bg-red-900/30 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
            <FaExclamationTriangle className="text-red-600 dark:text-red-500 text-2xl" />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
            Something went wrong
          </h2>
          
          <p className="text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
            We had trouble loading the blog content. This could be a temporary connection issue or a server hiccup.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => reset()}
              className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all active:scale-95"
            >
              <FaSync className={error ? "" : "animate-spin"} />  {/* ← FaSync here */}
              Try Again
            </button>
            
            <a
              href="/"
              className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200 font-semibold rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-all"
            >
              <FaHome />
              Back to Home
            </a>
          </div>
        </div>
        
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-8 p-4 bg-gray-100 dark:bg-gray-800 rounded-lg text-left overflow-auto max-w-full">
            <p className="text-xs font-mono text-red-500">Error: {error.message}</p>
          </div>
        )}
      </div>
    </SectionWrapper>
  );
}
